import { CourseComponent, Interval, Link } from "@models/ISchema";
import { LinkPageType } from "./linkData.reducer";
import { initialState } from "./EditSessionsContext";

/**
 * @param BlockRanges
 * @param LinkPageType
 *
 * @return LinkPageType
 */
export const blockRanges = (
  value: LinkPageType["blockRanges"],
  state: LinkPageType,
): LinkPageType => ({ ...state, blockRanges: value });

/**
 * @param Link
 * @param LinkPageType
 *
 * @return LinkPageType
 */
export const infoLink = (value: LinkPageType["info"], state: LinkPageType): LinkPageType => ({
  ...state,
  info: value,
});

/**
 * @param Block
 * @param LinkPageType
 *
 * @return LinkPageType
 */
export const rawBlocks = (value: LinkPageType["rawBlocks"], state: LinkPageType): LinkPageType => ({
  ...state,
  rawBlocks: value,
});

/**
 * @param Section[]
 * @param LinkPageType
 *
 * @return LinkPageType
 */
export const sectionLink = (
  value: LinkPageType["sections"],
  state: LinkPageType,
): LinkPageType => ({
  ...state,
  sections: value,
});

/**
 * @param link Link
 * @param state LinkPageType
 *
 * @return LinkPageType
 */
export const setAssignedWeeksByComponent = (link: Link, state: LinkPageType) => {
  const courseComponents = link?.course?.courseComponents ?? [];
  const assignedWeeksByComponent = courseComponents.reduce((acc: any, cc: CourseComponent) => {
    const component = cc?.component?.code;
    const weekIds: string[] = (cc?.impartationIntervals ?? ([] as Interval[])).map(
      interval => interval?.id,
    );

    if (!Object.prototype.hasOwnProperty.call(acc, component)) acc[component] = {};

    for (const weekId of weekIds) acc[component][weekId] = true;

    return acc;
  }, {});

  return { ...state, assignedWeeksByComponent };
};

/**
 * @param RecommendationsBySessionId
 * @param LinkPageType
 *
 * @return LinkPageType
 */
export const setRecommendations = (recommendations: any, state: LinkPageType): LinkPageType => ({
  ...state,
  recommendations,
});

export const setIsLoadingRecommendations = (
  isLoading: boolean,
  state: LinkPageType,
): LinkPageType => ({
  ...state,
  isLoadingRecommendations: isLoading,
});

export const setHasErrorsRecommendations = (
  hasErrors: boolean,
  state: LinkPageType,
): LinkPageType => ({
  ...state,
  hasErrorsRecommendations: hasErrors,
});

/**
 * @param IWeek
 * @param LinkPageType
 *
 * @return LinkPageType
 */
export const setSelectedWeek = (
  value: LinkPageType["selectedWeek"],
  state: LinkPageType,
): LinkPageType => ({ ...state, selectedWeek: value });

/**
 * @param TermPartsByCategory[]
 * @param LinkPageType
 *
 * @return LinkPageType
 */
export const termPartsByCategory = (
  value: LinkPageType["termPartsByCategory"],
  state: LinkPageType,
): LinkPageType => ({ ...state, termPartsByCategory: value });

/**
 * @param Week[]
 * @param LinkPageType
 *
 * @return LinkPageType
 */
export const weeksLink = (value: LinkPageType["weeks"], state: LinkPageType): LinkPageType => ({
  ...state,
  weeks: value,
});

export const cleanLinkData = (state: LinkPageType) => {
  return {
    ...state,
    ...structuredClone(initialState.link),
  };
};
